<template>
  <form id="add-collection"
        @submit.prevent="save(form)"
        @keydown="clearFormValidationError"
        @change="clearFormValidationError">
    <div class="set-after">
      <label>Illustration (700x250px minimum)</label>
      <div class="image-input">
        <div class="image-cell" v-if="!form.public_path"></div>
        <img v-else :src="form.cropPublicPath ? form.cropPublicPath : form.public_path"
             style="width: 100px; height: 100px" data-rjs="2">
        <button type="button" id="dropInput" :disabled="imageUploading"
                :action="imageSet ? imageSetImageApi.replace_image_set_image_url : imageSetImageApi.store_cover_image_url">
          <i class="fa fa-spinner fa-spin" v-if="imageUploading"></i> Upload Image
        </button>
        <strong class=""></strong>

        <validation-message :errors="form.errors" property-name="cover_image_id"></validation-message>
      </div>
    </div>
    <div class="set-after">
      <label for="title">Title</label>
      <input type="text" id="title" class="long-input" name="title" v-model="form.title">
      <validation-message :errors="form.errors" property-name="title"></validation-message>
    </div>
    <div class="set-after">
      <label>Description of whole collection (not required)</label>
      <ck-editor name="description" @change="clearFormValidationError" v-model="form.description"></ck-editor>

      <validation-message :errors="form.errors" property-name="description"></validation-message>
    </div>
    <div class="bootstrap-row">
      <div class="col-six">
        <label class="add-bottom">
          <input type="checkbox" name="show_error" v-model="form.show_in_portfolio">
          <span class="label-text">Include in main portfolio</span>
        </label>

        <validation-message :errors="form.errors" property-name="show_error"></validation-message>
      </div>
      <spinner v-if="!user"></spinner>
      <div class="col-six" v-else>
        <div v-if="user.has_published_book_access">
          <label class="add-bottom">
            <input type="checkbox" name="show_error" v-model="form.show_in_published_books">
            <span class="label-text">Include in published books</span>
          </label>

          <validation-message :errors="form.errors" property-name="show_error"></validation-message>
        </div>
        <div class="alert alert-info" v-else>
          <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
          <p>Increase exposure for this work by purchasing the Published Book upgrade.</p>
        </div>
      </div>
    </div>

    <div class="image-set__include-pb" v-if="user && user.has_published_book_access && form.show_in_published_books">
      <div class="set-after">
        <label for="publisher">Publisher</label>
        <input type="text" id="publisher" class="long-input" name="book.publisher" v-model="form.book.publisher">

        <validation-message :errors="form.errors" property-name="book.publisher"></validation-message>
      </div>
      <div class="set-after">
        <label for="title">Author</label>
        <input type="text" id="author" class="long-input" name="book.author" v-model="form.book.author">

        <validation-message :errors="form.errors" property-name="book.author"></validation-message>
      </div>
      <spinner v-if="categories === null"></spinner>
      <div class="set-after" v-else>
        <label for="category">Category</label>
        <div class="select-wrapper">
          <select name="book.category_id" id="category" class="long-input" v-model="form.book.category_id">
            <option :value="category.id" v-for="category in categories">{{category.name}}</option>
          </select>

          <validation-message :errors="form.errors" property-name="book.category_id"></validation-message>
        </div>
      </div>
    </div>
    <div class="collection-edit__btns" v-if="imageSet && !imageUploading">
      <router-link :to="{name: 'portfolio.collection.add-images', params: {id: imageSet.id}}"
                   class="collection-edit__btn _add-image">Add images
      </router-link>
      <router-link :to="{name: 'portfolio.collection.edit-images', params: {id: imageSet.id}}"
                   class="collection-edit__btn _add-image">Edit images
      </router-link>
    </div>
    <button type="submit" class="big-purple-button" v-if="!imageUploading">
      {{ imageSet ? 'Update' : 'Create &amp; Upload Images'}}
    </button>
  </form>
</template>

<script>
  import Form from './../../../../Form';
  import userApi from './../../../../api/user';
  import bookCategoryApi from './../../../../api/published-book/category';
  import imageSetImageApi from './../../../../api/image-set/images';
  import imageSetApi from './../../../../api/image-set';
  import retina from 'retinajs';

  export default {
    props: {
      save: {
        type: Function,
        required: true,
      },
      imageSet: {
        type: Object,
        default() {
          return null;
        },
      }
    },
    mounted() {
      this.fetchData();
      this.checkPublishedBookAccess();
      this.setupDropzone();

      if (this.imageSet) {
        this.prepareForm();
      }
    },
    data() {
      return {
        cropper: {
          show: false,
          imgSrc: '',
        },
        form: new Form({
          title: null,
          description: null,
          show_in_portfolio: (window.location.search.indexOf('published-books') === -1) ? true : false,
          show_in_published_books: (window.location.search.indexOf('published-books') === -1) ? false : true,

          book: {
            publisher: null,
            author: null,
            category_id: null,
          },

          cover_image_id: '',
          public_path: null,
          cropPublicPath: null,

          ...this.imageSet,
        }),
        user: null,
        categories: null,
        imageSetImageApi,
        imageUploading: false,
      }
    },
    methods: {
      fetchData() {
        bookCategoryApi.all().then((categories) => {
          this.categories = categories;
        });
      },
      prepareForm() {
        this.form.cover_image_id = this.imageSet.cover_image.id;
        this.form.public_path = this.form.cropPublicPath = this.imageSet.imagePath;

        if (!this.imageSet.book) {
          this.form.book = {
            publisher: null,
            author: null,
            category_id: null,
          };

          return;
        }
      },
      clearFormValidationError(event) {
        if (event.target.name) {
          this.form.errors.clear(event.target.name);
        }
      },
      checkPublishedBookAccess() {
        userApi.fetchUser().then((user) => {
          this.user = user;
        });
      },
      setupDropzone() {
        let self = this;

        Dropzone.options.dropInput = {
          paramName: 'image',
          createImageThumbnails: false,
          dictDefaultMessage: '',
          timeout: configs.dropzoneTimeout,
          params: {
            file_id: self.imageSet ? self.imageSet.cover_image.id : null,
            image_set_id: self.imageSet ? self.imageSet.id : null,
          },
          addedfile: function () {
            self.imageUploading = true;
          },
          error: function (f, data) {
            this.removeFile(f);

            self.imageUploading = false;

            let firstErrorKey = Object.keys(data.errors)[0],
              firstError = data.errors[firstErrorKey][0];    //Get first error

            toastr.error(firstError);
          },
          success: function (f, image) {
            this.removeFile(f);

            self.form.cover_image_id = image.id;
            self.form.public_path = image.public_path;

            self.form.cropPublicPath = image.imagePath;

            self.cropper.imgSrc = image.public_path;

            //If crop image wasn't created automatically (image height >= 400px)
            if (!self.form.cropPublicPath) {
              self.cropper.show = true;
            }

            self.imageUploading = false;
          }
        };

        $("#dropInput").dropzone({
          maxFiles: 1,
        });
      },
    },
  }
</script>